import { render, staticRenderFns } from "./AkbsMultiWageTable.vue?vue&type=template&id=69d86d4c&scoped=true&"
import script from "./AkbsMultiWageTable.vue?vue&type=script&lang=js&"
export * from "./AkbsMultiWageTable.vue?vue&type=script&lang=js&"
import style0 from "./AkbsMultiWageTable.vue?vue&type=style&index=0&id=69d86d4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d86d4c",
  null
  
)

export default component.exports